module.exports = __webpack_public_path__ + "img/gb941.prt.291074b6.jpg";